import React from "react";

import styles from "./style.css";

// interface ViewerOverlayTargetProps {
// placeholder for anything that
// we want to have on the viewer
// for the embed view
// }

const EmbedOverlay = ({}): JSX.Element | null => {
    return <div className={styles.container}></div>;
};

export default EmbedOverlay;
